import React, { cloneElement, ReactNode, Ref } from 'react';

export const useConnectedDropdownTrigger = (trigger: ReactNode, triggerRef: Ref<HTMLElement | null>, isOpened: boolean) => {
  if (!React.isValidElement(trigger)) {
    throw new Error('DropdownMenu requires single element as a child.');
  }

  return cloneElement(trigger, { ref: triggerRef, 'data-opened': isOpened });
};
